export default "__VITE_ASSET__620c696b__"